import React from 'react'
import { Box, Slider, Typography } from '@mui/material'

interface DeepcellSliderProps {
  value: number
  onChange: (event: Event, newValue: number | number[]) => void
  min: number
  max: number
  step?: number
  valueLabelDisplay?: 'auto' | 'off' | 'on'
  valueLabelFormat?: (value: number) => string
  showRangeLabels?: boolean
  minLabel?: string
  maxLabel?: string
  color?: string
}

const DeepcellSlider: React.FC<DeepcellSliderProps> = ({
  value,
  onChange,
  min,
  max,
  step = 1,
  valueLabelDisplay = 'auto',
  valueLabelFormat,
  showRangeLabels = true,
  minLabel,
  maxLabel,
  color = '#5F55D1'
}) => {
  const defaultMinLabel = minLabel || `${min}${valueLabelFormat ? valueLabelFormat(min).replace(min.toString(), '') : ''}`
  const defaultMaxLabel = maxLabel || `${max}${valueLabelFormat ? valueLabelFormat(max).replace(max.toString(), '') : ''}`

  return (
    <Box sx={{ px: 1 }}>
      <Slider
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        step={step}
        valueLabelDisplay={valueLabelDisplay}
        valueLabelFormat={valueLabelFormat}
        sx={{
          color,
          '& .MuiSlider-thumb': {
            backgroundColor: color,
          },
          '& .MuiSlider-track': {
            backgroundColor: color,
          },
          '& .MuiSlider-rail': {
            backgroundColor: '#e0e0e0',
          },
        }}
      />
      {showRangeLabels && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '-10px' }}>
          <Typography variant="caption" sx={{ color: '#666666', fontSize: '10px' }}>
            {defaultMinLabel}
          </Typography>
          <Typography variant="caption" sx={{ color: '#666666', fontSize: '10px' }}>
            {defaultMaxLabel}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default DeepcellSlider